import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const UsersCircle = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M15.3719249,13.3786028 L15.4496654,13.3832061 C17.9623721,13.6779386 19.909731,15.3549323 19.9969494,17.4373994 L20,17.5833334 L20,18.6666667 C20,19.0348565 19.7015232,19.3333334 19.3333334,19.3333334 C18.9914428,19.3333334 18.7096619,19.0759733 18.6711519,18.7444141 L18.6666667,18.6666667 L18.6666667,17.5833334 C18.6666667,16.1879422 17.2509525,14.9369657 15.2943346,14.7074606 C14.9286518,14.6645672 14.6669793,14.3333507 14.7098727,13.9676679 C14.7497024,13.6281053 15.038137,13.3782251 15.3719249,13.3786028 Z M9.33333332,13.3333333 C12.1828172,13.3333333 14.5675064,15.1197646 14.6636538,17.4377768 L14.6666667,17.5833334 L14.6666667,18.6666667 C14.6666667,19.0348565 14.3681898,19.3333333 13.9999999,19.3333333 C13.6581095,19.3333333 13.3763286,19.0759733 13.3378185,18.7444141 L13.3333333,18.6666667 L13.3333333,17.5833334 C13.3333333,16.019725 11.5711947,14.6666667 9.33333332,14.6666667 C7.15141844,14.6666667 5.42173755,15.9529177 5.3366172,17.4664754 L5.33333329,17.5833334 L5.33333329,18.6666667 C5.33333329,19.0348565 5.03485646,19.3333333 4.66666662,19.3333333 C4.32477606,19.3333333 4.04299518,19.0759733 4.0044851,18.7444141 L3.99999995,18.6666667 L3.99999995,17.5833334 C3.99999995,15.1949746 6.42448522,13.3333333 9.33333332,13.3333333 Z M14.6666667,4.66666662 C16.6888565,4.66666662 18.3333334,6.31114346 18.3333334,8.33333331 C18.3333334,10.3555232 16.6888565,12 14.6666667,12 C14.4704554,12 14.2891605,11.979796 14.0511357,11.9391576 C13.6881976,11.8771926 13.4442107,11.5327405 13.5061757,11.1698024 C13.5681408,10.8068642 13.9125929,10.5628773 14.275531,10.6248424 L14.4561126,10.6521217 C14.5360701,10.6620742 14.6028185,10.6666666 14.6666667,10.6666666 C15.9524769,10.6666666 17,9.61914349 17,8.33333331 C17,7.04752314 15.9524769,5.99999996 14.6666667,5.99999996 C14.5581369,5.99999996 14.4406993,6.01295779 14.2770063,6.04145494 C13.9142722,6.10460299 13.5690264,5.86174046 13.5058784,5.49900629 C13.4427303,5.13627212 13.6855928,4.79102636 14.048327,4.72787831 C14.2810565,4.68736264 14.4686259,4.66666662 14.6666667,4.66666662 Z M9.33333332,4.66666662 C11.3583774,4.66666662 13,6.30828922 13,8.33333331 C13,10.3583774 11.3583774,12 9.33333332,12 C7.30828922,12 5.66666663,10.3583774 5.66666663,8.33333331 C5.66666663,6.30828922 7.30828922,4.66666662 9.33333332,4.66666662 Z M9.33333332,5.99999996 C8.04466889,5.99999996 6.99999997,7.04466889 6.99999997,8.33333331 C6.99999997,9.62199773 8.04466889,10.6666667 9.33333332,10.6666667 C10.6219977,10.6666667 11.6666667,9.62199773 11.6666667,8.33333331 C11.6666667,7.04466889 10.6219977,5.99999996 9.33333332,5.99999996 Z"
        id="path-1-user-circle"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/people/users/line">
        <mask id="mask-2-user-circle" fill="white">
          <use xlinkHref="#path-1-user-circle"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-user-circle"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-user-circle)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
